import { PublicAuthenticationContextProvider } from '@solinkcorp/authentication';
import { KeyActionsProvider } from '@solinkcorp/solink-components';
import { CacheProvider } from 'components/CacheContext';
import React from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import { Provider } from 'react-redux';
import { getReduxStore } from 'stores/store';
import { ThemeProvider } from 'styled-components';
import { DEFAULT_THEME } from 'styles/styled';
import './styles/App.sass';

const PublicWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <ThemeProvider theme={DEFAULT_THEME}>
      <KeyActionsProvider>
        <Provider store={getReduxStore()}>
          <PublicAuthenticationContextProvider>
            <CacheProvider>{children}</CacheProvider>
          </PublicAuthenticationContextProvider>
        </Provider>
      </KeyActionsProvider>
    </ThemeProvider>
  );
};

export default PublicWrapper;
